import React, { useEffect } from "react";
import dialog from "../../assets/images/pk-events/image 33 (1).png";
import close from "../../assets/images/pk-events/close.png";
import { useTranslation } from "react-i18next";

const Dialog = ({ isOpen, closeDialog, description }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black   bg-opacity-50 flex items-center justify-center z-[999999]">
      <div
        style={{ width: "calc(100% - 20px)" }}
        className="w-[90%]  rounded-xl    relative dialog  shadow-lg"
      >
        <img
          src={dialog}
          alt="dialog"
          className="inset-0 w-full h-[65%] object-cover rounded-2xl"
        />
        <div className="absolute  top-[72px] h-[80%] inset-0 flex justify-center items-center">
          <p
            className="font-lemon w-[90%] scrollbar-hidden  overflow-y-auto text-[#000] md:text-xl sm:text-xl font-normal md:leading-[38.32px] xs:leading-[28.32px] text-center px-4 py-2"
            style={{
              maxHeight: "60%", // Limit the height to prevent overflow
              overflowY: "auto", // Add scroll if the content is too long
              whiteSpace: "normal", // Ensure text wraps
            }}
          >
            {description}
          </p>
        </div>
        <p className="absolute top-[42px] font-lemon left-1/2 w-full p-4 z-40 transform -translate-x-1/2 text-[#000]  xs:text-xl font-normal text-center">
          {t("Rules")}
        </p>
        <button
          onClick={closeDialog}
          className="absolute top-[3.3rem] z-50 right-[1%]"
        >
          <img src={close} alt="close" className="w-8" />
        </button>
      </div>
    </div>
  );
};

export default Dialog;
